import React from 'react'
import PropTypes from 'prop-types';
import { IMaskInput } from 'react-imask';

const InputMaskZip = React.forwardRef(function InputMaskZip(props, ref) {
  const { onChange, inputRef, ...inputMaskProps } = props;

  return (
    <IMaskInput
      {...inputMaskProps}
      inputRef={ref || inputRef}
      mask="00000"
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      placeholderChar=" "
    />
  )
});

InputMaskZip.propTypes = {
  inputRef: PropTypes.any,
  onChange: PropTypes.func.isRequired
}

export default InputMaskZip;